import { VideoPlaceHolder } from "~/common/components/video/VideoPlaceHolder";
import { ABOUT_CN_VIDEO_ID, VideoWidgetAttributes } from "~/models/videoprops";

export const VideoEdit = ({ videoId }: VideoWidgetAttributes) => {
  return (
    <div className="tw:w-full">
      <VideoPlaceHolder videoId={videoId ?? ABOUT_CN_VIDEO_ID} />
    </div>
  );
};
